import { useToast } from '@chakra-ui/react';
import ErrorToast from '../common/ErrorToast';
import sentry from '../sentry';
import { getErrorResponsePayload } from '../utils/ajax';
import type { ToastDescription } from '../common/CustomToast';

export interface ReportAndToastApiErrorOptions {
  title?: string;
  description?: ToastDescription;
  silentCodes?: number[];
}

export const useReportAndToastApiError = () => {
  const toast = useToast();

  return (error: unknown, options: ReportAndToastApiErrorOptions = {}) => {
    sentry.sendError(error);
    const payload = getErrorResponsePayload(error);
    const silentCodes = options.silentCodes ?? [401];

    if (!silentCodes.includes(payload.code)) {
      toast({
        render: (props) => (
          <ErrorToast
            error={error}
            title={options.title}
            description={options.description}
            onClose={props.onClose}
          />
        ),
      });
    }

    return payload;
  };
};
